import pxToRem from "assets/theme/functions/pxToRem";

const DrawerBreakPoint = {
  baseTitleBreakPoint: {
    xs: pxToRem(18),
    sm: pxToRem(18),
    md: pxToRem(20),
    lg: pxToRem(20),
    xl: pxToRem(20),
    xxl: pxToRem(20),
    fhd: pxToRem(22),
    uhd: pxToRem(24),
  },
};

export default DrawerBreakPoint;
